export const PROGRAM_PHASES = ['testing', 'live', 'ended'] as const;
export type ProgramPhase = typeof PROGRAM_PHASES[number];

export const isProgramPhase = (phase: string): phase is ProgramPhase => {
  return PROGRAM_PHASES.includes(phase as ProgramPhase);
};

export const getPhaseConfig = (phase: ProgramPhase): Record<string, boolean> => {
  return {
    pause_rc_payments: phase !== 'live',
    no_cron: phase === 'ended',
    no_roboscreener: phase === 'ended',
  };
};
